// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/tag/style/index.less
// module id = 1076
// module chunks = 1